<template>
  <Layout>
    <!-- 面包屑 -->
    <div class="w-full bg-gray-100 py-3">
      <div class="max-w-6xl mx-auto px-4 lg:px-8">
        <ol class="flex items-center text-sm text-gray-500">
          <li><router-link to="/" class="hover:text-primary">Home</router-link></li>
          <li class="before:content-['/'] before:mx-2 text-gray-800">Blog</li>
        </ol>
      </div>
    </div>

    <div class="max-w-6xl mx-auto px-4 lg:px-8 py-6">
      <div class="flex gap-8">
        <div class="w-full">
          <h2 class="text-2xl lg:text-4xl font-bold text-gray-800 mb-5">News and Events</h2>
          <div class="flex flex-col space-y-6">
            <div
              v-for="(news, index) in newsList"
              :key="index"
              class="group flex flex-col gap-3 md:flex-row md:gap-5 py-5 border-b border-gray-200 last:border-b-0 cursor-pointer hover:bg-gray-50 transition-colors duration-200"
              @click="handleNewsClick(news.id)">
              <div class="shrink-0 w-full h-[180px] md:w-[120px] md:h-[120px] overflow-hidden bg-gray-100">
                <img :src="news.imageUrl" :alt="news.title" class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105">
              </div>
              <div class="flex-1 min-w-0">
                <h3 class="text-base font-bold text-gray-800 mb-2 leading-relaxed group-hover:text-primary-dark">{{ news.title }}</h3>
                <p class="text-sm text-gray-500 leading-relaxed line-clamp-3">{{ news.description }}</p>
              </div>
              <div class="shrink-0 w-full text-left md:w-[100px] md:text-right text-sm text-gray-400">{{ news.date }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/common/CommonLayout";

export default {
  name: "BlogView",
  components: { Layout },
  data() {
    return {
      newsList: []
    }
  },
  mounted() {
    this.getArticles()
  },
  methods: {
    async getArticles() {
      const resp = await this.getRequest("/api/articles")
      if (resp && resp.data) {
        this.newsList = (resp.data.data?.records || resp.data.data || []).map(item => ({
          id: item.id,
          title: item.title,
          description: item.description,
          imageUrl: item.imageUrl,
          date: item.publishDate
        }))
      }
    },
    handleNewsClick(newsId) {
      this.$router.push({ path: `/news/newsId/${newsId}` });
    }
  }
}
</script>

